import React from "react";
import { Card, Table, Button, message } from "antd";
import { useLocation, useNavigate } from "react-router-dom";
import generateUserActivityLogExcel from "../../Utils/UserActivityLogExcel";
import { generatePDF } from "../../Utils/pdfExport";

const UserActivityLogTable = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { tableData, reportTitle } = location.state || {};

    if (!tableData || tableData.length === 0) {
        navigate(-1);
        return null;
    }

    const enrichedData = tableData.map((item, idx) => ({
        ...item,
        index: idx + 1
    }));

    const handleExportExcel = () => {
        generateUserActivityLogExcel(tableData);
        message.success("Excel report generated successfully");
    };

    const handleExportPDF = () => {
        const columns = [
            { title: "No.", dataIndex: "index", key: "index" },
            { title: "Full Name", dataIndex: "fullName", key: "fullName" },
            { title: "NIC No", dataIndex: "nic", key: "nic" },
            { title: "Date/Time", dataIndex: "logTime", key: "logTime" },
            { title: "Activity", dataIndex: "activityName", key: "activityName" },
            { title: "Status", dataIndex: "state", key: "state" },
            { title: "Designation", dataIndex: "designation", key: "designation" },
            { title: "Branch", dataIndex: "branchName", key: "branchName" },
        ];
        generatePDF(reportTitle, columns, enrichedData);
    };

    return (
        <div style={{ padding: 10 }}>
            <Card style={{ border: '1px solid #f0f0f0', borderRadius: '5px', boxShadow: '0 2px 8px rgba(51, 39, 39, 0.1)' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 12 }}>
                    <Button type="default" onClick={() => navigate(-1)}>
                        Back
                    </Button>
                    <h3 style={{ margin: 0 }}>{reportTitle}</h3>
                    <div style={{ display: 'flex', gap: 8 }}>
                        <Button type="primary" onClick={handleExportExcel} icon={<span>📊</span>}>
                            Export Excel
                        </Button>
                        <Button type="default" onClick={handleExportPDF} icon={<span>📄</span>}>
                            Export PDF
                        </Button>
                    </div>
                </div>
                <div style={{ maxHeight: "70vh", overflow: "auto" }}>
                    <Table
                        dataSource={enrichedData}
                        columns={[
                            { title: "No.", dataIndex: "index", key: "index", width: 60 },
                            { title: "Full Name", dataIndex: "fullName", key: "fullName", width: 200 },
                            { title: "NIC No", dataIndex: "nic", key: "nic", width: 140 },
                            { title: "Date/Time", dataIndex: "logTime", key: "logTime", width: 180 },
                            { title: "Activity", dataIndex: "activityName", key: "activityName", width: 250 },
                            { title: "Status", dataIndex: "state", key: "state", width: 120 },
                            { title: "Designation", dataIndex: "designation", key: "designation", width: 150 },
                            { title: "Branch", dataIndex: "branchName", key: "branchName", width: 180 },
                        ]}
                        bordered
                        pagination={false}
                        size="middle"
                        rowClassName={(record, index) => index % 2 === 1 ? 'ant-table-row-alt' : ''}
                    />
                </div>
            </Card>
        </div>
    );
};

export default UserActivityLogTable;